import { ChangeDetectionStrategy, Component, inject, signal } from '@angular/core';
import { tap } from 'rxjs';
import { ImageWithoutImageDataResource } from 'src/app/client-api.service';
import { ImagesService } from 'src/app/shared/image-service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-image-list',
  templateUrl: './image-list.component.html',
  styleUrls: ['./image-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class ImageListComponent {

  imageService = inject(ImagesService)
  images = this.imageService.images
      
  selectedImageUrl = signal<string | undefined>(undefined);

  onDelete(id: number) {
    if(confirm('Are you sure you want to delete this image?')) {
      this.imageService.deleteImage(id).pipe(
        tap(() => this.imageService.triggerImagesRefresh())
      ).subscribe();
    }
  }
  
  openImagePopup(image: ImageWithoutImageDataResource) {
    const imageUrl = environment.apiBaseUrl + '/api/v1/logoImage/get-image-file-by-id/' + image.id;
    this.selectedImageUrl.set(imageUrl);
  }

  closeImagePopup() {
    this.selectedImageUrl.set(undefined);
  }  
}

